import React from 'react';
import QuestionCard from './QuestionCard';

function AdminUserAnswers(props) {
    return (
        <div style={{ border: '1px solid black', borderRadius: '20px', padding: '20px 20px 20px 20px' }}>
            <h3>{props.data.employeeId} {props.employeeData.name} {props.employeeData.surname}</h3>
            <h5 style={{ color: 'grey' }}>{props.data.date}-{props.data.month}-{props.data.year} {props.data.hour}:{props.data.minute}:{props.data.second}</h5>
            <h4>คะแนน <span style={{color:'blue'}}>{props.data.score} / {props.data.answers.length}</span></h4>
            <div>
            {
                props.data.answers.map((q, i) => {
                    return (
                        <div key={i}>
                            <QuestionCard 
                                key={`card${i}`} 
                                isEditing={false}
                                isProcessing={false}
                                docId={i}
                                order={q.order}
                                question={q.question} 
                                choices={q.choices} 
                                answer={q.answer} 
                                userAnswer={q.userAnswer}
                                showUserAnswer={true}
                                hideActionButtons={true}
                            />
                        </div>
                    );
                })
            }
            </div>
        </div>
    );
}

export default AdminUserAnswers;
